import { buildModelManager } from "../builder.js";
const DefaultShopifyAppSubscriptionSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  currentPeriodEnd: true,
  lineItems: true,
  name: true,
  returnUrl: true,
  shopId: true,
  shopifyCreatedAt: true,
  status: true,
  test: true,
  trialDays: true,
  updatedAt: true
};
const modelApiIdentifier = "shopifyAppSubscription";
const pluralModelApiIdentifier = "shopifyAppSubscriptions";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyAppSubscriptionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyAppSubscriptionSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyAppSubscriptionSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyAppSubscriptionSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyAppSubscriptionSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyAppSubscriptionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyAppSubscriptionSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shopifyAppSubscriptionGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyAppSubscription does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyAppSubscriptionManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyAppSubscriptionSelection,
  operations
);
export {
  DefaultShopifyAppSubscriptionSelection,
  ShopifyAppSubscriptionManager
};
//# sourceMappingURL=ShopifyAppSubscription.js.map
